module.exports = __webpack_public_path__ + "static/media/design.bd8320a1.png";